module.exports = __webpack_public_path__ + "img/img_uniform_clear.7c3b1665.jpg";